import React, { useState } from 'react';
import { useCommandeContext, changeValeur } from '../contexts/CommandeContext';
import { Grid } from '@mui/material';
import GenericText from './forms/GenericText';
import Message from './messages/Message';
import { useFetch } from 'use-http';
import ButtonNav from './button/ButtonNav';


export default function CommandeCodePromo({ disabled }) {

	// Initialisation des variables d'état du composant
	const [codeValid, setCodeValid] = useState(false);
	const [message, setMessage] = useState('');

	// Recupération de la commande et du dispatcher à partir du CommandeContext
	const { commande, dispatch } = useCommandeContext();

	// Initialisation de l'accés au backend
	const { post, response, loading } = useFetch(process.env.REACT_APP_BACKEND_API_URL, { cachePolicy: 'no-cache' });

	const handleValidationCodePromo = async () => {

		if (commande.codePromo !== '') {
			// Initialisation des paramètres de la requête pour la validation du code promo
			let calculRemise = {
				"codeCoupon": commande.codePromo,
				"montantInitial": commande.creneau.tarifs.PAIEMENT_IMMEDIAT.montantTotal
			};

			// Appel du service de validation de code promo et de calcule de la remise
			let res = await post('/remise/calcul-remise', calculRemise);

			// Si la requête a aboutit
			if (response.ok) {

				// On initialise les variables en fonction
				dispatch(changeValeur('remise', res.statut === 0 ? res.data : undefined));
				setCodeValid(res.statut === 0);
				setMessage(res.message);
				
				if(!commande.produit.displayPrix) {
					if(res.statut === 0){
						setMessage('Le code promo <b>'+ commande.codePromo +'</b> est valide. Il sera pris en compte sur votre facture lors de la validation de votre devis.');
					}else{
						setMessage('Le code promo <b>'+ commande.codePromo +'</b> n\'est plus valide.');
					}
					
				}

			} else { // Si l'appel de la requête au service échoue
				dispatch(changeValeur('remise',undefined));
				setCodeValid(false);
				setMessage('');
			}

		} else { // Si la valeur du code promo n'est pas saisie
			dispatch(changeValeur('remise',undefined));
			setCodeValid(false);
			setMessage('');
		}
	};

	return (
		<Grid container justifyContent="center" my={2}>

			<Grid item xs={12} sm={12} md={11} lg={11} xl={8}>
				<Message props={{ type: 'info', message: 'Si vous disposez d\'un code promo, saisissez le code puis cliquez sur le bouton Valider pour bénéficier du nouveau tarif.' }} />
			</Grid>

			<Grid item xs={8} sm={5} md={5} mt={2}>
				<GenericText
					required={false}
					disabled={disabled}
					id="codePromo"
					name="codePromo"
					label="Code promo"
				/>
			</Grid>
			<Grid item xs={4} sm={3} md={3} sx={{ display: 'flex', justifyContent: 'center' }} mt={2}>
				<ButtonNav props={{ text: 'Valider', tracking: 'payment-begin-btn' }} action={handleValidationCodePromo} disabled={loading || disabled} />
			</Grid>

			{message !== '' &&
				<Grid item xs={12} sm={12} md={11} lg={11} xl={8} mt={2}>
					<Message props={{ type: codeValid ? 'success' : 'error', message: message }} />
				</Grid>
			}

		</Grid>
	);
}